import { render, staticRenderFns } from "./hhdzTable.vue?vue&type=template&id=1ccb15c1&scoped=true"
import script from "./hhdzTable.vue?vue&type=script&lang=ts"
export * from "./hhdzTable.vue?vue&type=script&lang=ts"
import style0 from "./hhdzTable.vue?vue&type=style&index=0&id=1ccb15c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb15c1",
  null
  
)

export default component.exports